module.exports = __webpack_public_path__ + "fonts/Rimouski.6759bd4a.eot";